// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-user-table-card {
    background: var(--sa-card);
    border-radius: 14px;
    overflow: hidden;
}

.sa-user-search {
    background: var(--sa-bg);
    border: 1px solid var(--sa-border);
    border-radius: 10px;
    padding: 8px 16px;
    color: var(--sa-text);
    font-size: 13px;
    width: 300px;
    outline: none;
    transition: border-color 0.15s;
}

.sa-user-search:focus {
    border-color: var(--sa-teal);
}

.sa-table {
    width: 100%;
    border-collapse: collapse;
}

.sa-table th {
    padding: 12px 18px;
    text-align: left;
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    color: var(--sa-dim);
    border-bottom: 1px solid var(--sa-border);
}

.sa-table td {
    padding: 14px 18px;
    border-bottom: 1px solid var(--sa-border);
    font-size: 13px;
}

.sa-action-btn {
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all 0.15s;
    background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SAUserMgmt.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;IACrB,uBAAuB;AAC3B","sourcesContent":[".sa-user-table-card {\n    background: var(--sa-card);\n    border-radius: 14px;\n    overflow: hidden;\n}\n\n.sa-user-search {\n    background: var(--sa-bg);\n    border: 1px solid var(--sa-border);\n    border-radius: 10px;\n    padding: 8px 16px;\n    color: var(--sa-text);\n    font-size: 13px;\n    width: 300px;\n    outline: none;\n    transition: border-color 0.15s;\n}\n\n.sa-user-search:focus {\n    border-color: var(--sa-teal);\n}\n\n.sa-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.sa-table th {\n    padding: 12px 18px;\n    text-align: left;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    color: var(--sa-dim);\n    border-bottom: 1px solid var(--sa-border);\n}\n\n.sa-table td {\n    padding: 14px 18px;\n    border-bottom: 1px solid var(--sa-border);\n    font-size: 13px;\n}\n\n.sa-action-btn {\n    padding: 6px 10px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: all 0.15s;\n    background: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
